let booleanRestrictionsJSON = require("json!../static/booleanRestrictions.json");

const $inject = [];
const booleanRestrictionService = function () {
  let service = {};

  service.get = function get() {
    return booleanRestrictionsJSON;
  };

  return service;
};

booleanRestrictionService.$inject = $inject;

export default booleanRestrictionService;


// WEBPACK FOOTER //
// ./src/services/booleanRestrictionService.js